import { service } from '@ember/service';
import Component from '@glimmer/component';

export default class BackOfANapkinSlideoversReturnConfidenceComponent extends Component {
  @service organisation;

  get lowConfidence() {
    return this.organisation.returnConfidenceOptions.filter(
      (item) => item.label === 'Low',
    )[0].value;
  }

  get mediumConfidence() {
    return this.organisation.returnConfidenceOptions.filter(
      (item) => item.label === 'Medium',
    )[0].value;
  }

  get highConfidence() {
    return this.organisation.returnConfidenceOptions.filter(
      (item) => item.label === 'High',
    )[0].value;
  }
}
